import React, { Component } from 'react';
import { Route, Switch, HashRouter as Router } from 'react-router-dom';
import routes from './routes';
import './custom.css';
import './App.scss';
import { initVersionCheck } from './helpers/helpersIndex';
class App extends Component {

  componentDidMount() {
    if (process.env.NODE_ENV === 'production')
      initVersionCheck('version.json');
  }
  render() {
    return (
      <React.Fragment>
        <Router >
          <Switch>
            {routes.map((route, idx) => <Route path={route.path} exact component={route.component} key={idx} />)}
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}
export default App;